var utils = require('../../utils')

export default {
  name: 'forgot-password',
  utils: utils,
  data: function () {
    return {
      email: null,
      isSuccess: false,
      message: null,
      showMessage: false
    }
  },
  created: function () {
    this.$store.dispatch('CLEAR_AUTH_STATUS')
  },
  computed: {
    isForgotPasswordSuccess () {
      return (this.$store.getters.authStatus === 'success')
    }
  },
  methods: {
    /** 送信可否 */
    canSubmit: function () {
      if (utils.isBlank(this.email)) {
        return false
      }
      if (!utils.isEmail(this.email)) {
        return false
      }
      return true
    },

    /** メール送信 */
    sendMail: function() {
      this.showMessage = false
      var reset_url = location.href
      reset_url = reset_url.substr(0, reset_url.lastIndexOf("#")) + "#/reset_password"
      var form = new FormData()
      form.append('email', this.email)
      form.append('reset_url', reset_url)
      this.$store.dispatch('PASSWORD_RESET_MAIL_SEND', {data: form})
      .then(
        (res) => {
          this.message = this.$t('forgot_password.completed')
          this.showMessage = true
        },
        () => {
          this.message = this.$store.getters.authError || this.$store.getters.apiError
          this.showMessage = true
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/forgot-password.js